import { CONNECT_ITEM_AMD_MODULE } from '@atlassian/jira-dashboard-common/src/constants.tsx';
import type { GadgetData } from '@atlassian/jira-dashboard-common/src/types.tsx';

export const isConnectGadget = ({ amdModule }: Pick<GadgetData, 'amdModule'>): boolean =>
	amdModule === CONNECT_ITEM_AMD_MODULE;
